export const formClassName = "p-2 mx-10 shadow-xl rounded-lg bg-zinc-200 dark:bg-eerieBlack";
export const fieldClassName = "rounded-md dark:bg-zinc-500";
